export default function validaCampo (props) {
  const { name, value, setError, wasTouched, hasError, valida } = props;
  let message = valida(value)
  if (hasError && !message) {
    setError(name, null)
  } else {
    if (wasTouched(name) && !hasError && message) {
      setError(name, message)
    }
  }
}
